
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"55","height":"55","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42.25 34.53h3.199a2.98 2.98 0 002.961-2.975v-19.31a2.98 2.98 0 00-2.955-2.98h-3.2c-1.63.006-2.962 1.344-2.968 2.98v1.046h-3.782l-3.651-2.467a4.536 4.536 0 00-2.528-.777H23.82a4.545 4.545 0 00-3.508 1.72l-1.184 1.495H9.969v-1.046c-.018-1.62-1.344-2.945-2.962-2.951H3.8C2.172 9.27.846 10.609.84 12.245v19.31a2.985 2.985 0 002.967 2.976h3.2a2.98 2.98 0 002.962-2.976v-1.057h3.734l7.119 7.151a4.538 4.538 0 006.19.245l6.471-5.628a4.604 4.604 0 001.202-1.619l.065-.143h4.532v1.057a2.992 2.992 0 002.967 2.97zM42.01 12h3.681l.012 19.818h-3.693V12.001zM7.245 31.795H3.564V12.001h3.68v19.793zm24.62-1.709l-.035.102-.048.042-6.535 5.634a1.83 1.83 0 01-1.202.448c-.47 0-.945-.18-1.302-.532l-7.505-7.558a1.364 1.364 0 00-.952-.4H9.975v-11.83h6.91l-2.076 2.612a1.366 1.366 0 00-.29 1.003c.04.365.22.687.505.914l2.099 1.625a4.577 4.577 0 005.834-.197l2.426-2.15 6.637 7.742c.63.747.56 1.876-.154 2.546zm3.081-2.288l-.041-.19a4.622 4.622 0 00-.869-1.835l-7.51-8.824a1.357 1.357 0 00-.946-.472 1.43 1.43 0 00-1 .346l-3.449 3.017a1.855 1.855 0 01-2.337.006l-.97-.746 4.586-5.748c.35-.442.868-.693 1.427-.693h5.501c.363 0 .72.108 1.023.31l3.996 2.683c.226.15.482.233.756.233h4.175l.011 11.907h-4.353v.006z","fill":"#88C0B3"}})])
          )
        }
      }
    